import React, { forwardRef, useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  Heading,
  Button,
  IconButton,
  Collapse,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  FormControl,
  FormLabel,
  Stack,
  Divider,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  position,
  Grid,
} from "@chakra-ui/react";
import {
  AddIcon,
  DeleteIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import CustomInput from "components/common/customInput/CustomInput";
import _, { values } from "lodash";
import { FaPlus } from "react-icons/fa";

const DynamicForm = forwardRef(
  (
    {
      data,
      onDataChange,
      workFlowData,
      accountDetails,
    }: { workFlowData: any; accountDetails: any; data: any; onDataChange: any },
    ref
  ) => {
    const [openAddModal, setOpenAddModal] = useState<any>({
      open: false,
      key: "",
      data: {
        editedValues: "",
        originalValues: "",
      },
      keyPath: "",
      index: 0,
      position: "after",
      nested: false,
    });

    const [openKeyModal, setOpenKeyModal] = useState<any>({
      open: false,
      key: "",
      keyPath: "",
      index: 0,
      position: "after",
      nested: false,
      type: "object",
    });

    const [payload, setPayload] = useState(data);
    const [collapsed, setCollapsed] = useState<{ [key: string]: boolean }>({});

    useEffect(() => {
      setPayload(data);
      setCollapsed({});
    }, [data]);

    const toggleCollapse = (key: string) => {
      setCollapsed((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    function convertCamelCaseToSentence(str: string) {
      return str
        .replace(/([A-Z])/g, " $1")
        .trim()
        .toLowerCase();
    }

    const handleUpdate = (keyPath: string[], newValue: any) => {
      const updatedPayload = _.cloneDeep(payload);
      const currentValue = _.get(updatedPayload, keyPath);
      if (!currentValue || !currentValue.hasOwnProperty("originalValues")) {
        _.set(updatedPayload, [...keyPath, "originalValues"], currentValue);
      }
      _.set(updatedPayload, [...keyPath, "editedValues"], newValue);
      setPayload(updatedPayload);
      onDataChange(updatedPayload);
    };

    const addData = (
      keyPath: string | string[],
      index?: number,
      position?: "above" | "below",
      nested?: boolean
    ) => {
      try {
        console.log("parammeters", keyPath, index, nested);
        const updatedPayload = _.cloneDeep(payload);
        let target: any;
        if (nested) {
          console.log(true);
          target = _.get(updatedPayload, keyPath);
        } else {
          target = updatedPayload;
        }
        console.log("target", target);
        if (Array.isArray(target)) {
          const newItem =
            target.length > 0
              ? createNewItemFromSchema(target[0])
              : { originalValues: "", editedValues: "" };

          if (typeof index === "number" && position) {
            const insertIndex = position === "above" ? index : index + 1;
            target.splice(insertIndex, 0, newItem);
          } else {
            target.push(newItem);
          }

          _.set(updatedPayload, keyPath, target);
        } else if (typeof target === "object" && target !== null) {
          setOpenAddModal({
            keyPath,
            data: { originalValues: "", editedValues: "" },
            open: true,
            index: index,
            position: position,
            nested: nested,
          });
        }

        setPayload(updatedPayload);
        onDataChange(updatedPayload);
      } catch (error) {
        console.error("Error adding data:", error);
      }
    };

    const addModalData = () => {
      let target: any;

      if (openAddModal?.nested) {
        console.log(true);
        const updatedPayload = _.cloneDeep(payload);
        target = _.get(updatedPayload, openAddModal?.keyPath);

        if (
          typeof target === "object" &&
          target !== null &&
          !Array.isArray(target)
        ) {
          const newKey = openAddModal.key;
          const newItem = {
            editedValues: openAddModal.data.editedValues,
            originalValues: "",
          };

          if (newKey) {
            const keys = Object.keys(target);
            const values = Object.values(target);

            const insertIndex =
              typeof openAddModal.index === "number" && openAddModal.position
                ? openAddModal.position === "above"
                  ? openAddModal.index
                  : openAddModal.index + 1
                : keys.length;

            keys.splice(insertIndex, 0, newKey);
            values.splice(insertIndex, 0, newItem);

            const reorderedObject = keys.reduce(
              (acc: any, key: any, i: any) => {
                acc[key] = values[i];
                return acc;
              },
              {}
            );

            _.set(updatedPayload, openAddModal.keyPath, reorderedObject);
            setPayload(updatedPayload);
            onDataChange(updatedPayload);
          }
        }
      } else {
        console.log(false);
        target = payload;

        if (
          typeof target === "object" &&
          target !== null &&
          !Array.isArray(target)
        ) {
          const newKey = openAddModal.key;
          const newItem = {
            editedValues: openAddModal.data.editedValues,
            originalValues: "",
          };

          if (newKey) {
            const keys = Object.keys(target);
            const values = Object.values(target);

            const insertIndex =
              typeof openAddModal.index === "number" && openAddModal.position
                ? openAddModal.position === "above"
                  ? openAddModal.index
                  : openAddModal.index + 1
                : keys.length;

            keys.splice(insertIndex, 0, newKey);
            values.splice(insertIndex, 0, newItem);

            const reorderedObject = keys.reduce(
              (acc: any, key: any, i: any) => {
                acc[key] = values[i];
                return acc;
              },
              {}
            );

            setPayload(reorderedObject);
            onDataChange(reorderedObject);
          }
        }
      }

      setOpenAddModal({
        key: "",
        data: { originalValues: "", editedValues: "" },
        keyPath: "",
        open: false,
        index: 0,
        position: "after",
        nested: false,
      });
    };

    const addEmptyObject = (
      keyPath: string | string[],
      newKey: string,
      index: number,
      position?: "above" | "below",
      nested?: boolean,
      type?: string
    ) => {
      try {
        const updatedPayload = _.cloneDeep(payload);

        let target: any;
        if (nested) {
          target = _.get(updatedPayload, keyPath);
        } else {
          target = updatedPayload;
        }

        const newObject = type === "array" ? [] : {};

        if (
          typeof target === "object" &&
          target !== null &&
          !Array.isArray(target)
        ) {
          const keys = Object.keys(target);
          const values = Object.values(target);

          const insertIndex =
            typeof index === "number" && position
              ? position === "above"
                ? index
                : index + 1
              : keys.length;

          keys.splice(insertIndex, 0, newKey);
          values.splice(insertIndex, 0, newObject);

          const reorderedObject = keys.reduce(
            (acc: any, key: string, i: number) => {
              acc[key] = values[i];
              return acc;
            },
            {}
          );

          if (nested) {
            _.set(updatedPayload, keyPath, reorderedObject);
          } else {
            setPayload(reorderedObject);
            onDataChange(reorderedObject);
            return;
          }
        } else if (Array.isArray(target)) {
          const insertIndex =
            typeof index === "number" && position === "above"
              ? index
              : index + 1;
          target.splice(insertIndex, 0, { [newKey]: newObject });
        }

        setPayload(updatedPayload);
        onDataChange(updatedPayload);
      } catch (error) {
        console.error("Error adding empty object:", error);
      }
    };

    const createNewItemFromSchema = (schema: any) => {
      if (typeof schema === "object" && schema !== null) {
        if (Array.isArray(schema)) {
          return [];
        }

        const newItem: any = {};
        for (const key in schema) {
          if (typeof schema[key] === "object" && schema[key] !== null) {
            newItem[key] = createNewItemFromSchema(schema[key]);
          } else {
            newItem[key] = "";
          }
        }
        return newItem;
      }
      return "";
    };

    const deleteData = (keyPath: any) => {
      const updatedPayload = _.cloneDeep(payload);

      _.unset(updatedPayload, keyPath);

      const cleanUpEmptyParents = (obj: any, path: string | string[]) => {
        const keys = Array.isArray(path) ? path : path.split(".");
        if (keys.length === 0) return;

        let current = obj;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!current[keys[i]]) return;
          current = current[keys[i]];
        }

        const lastKey = keys[keys.length - 1];
        if (current && _.isEmpty(current[lastKey])) {
          delete current[lastKey];
          cleanUpEmptyParents(obj, keys.slice(0, -1));
        }
      };

      cleanUpEmptyParents(updatedPayload, keyPath);
      setPayload(updatedPayload);
      onDataChange(updatedPayload);
    };

    const renderFields = (
      obj: any,
      parentPath: string[] = [],
      nested: boolean = false
    ) => {
      if (typeof obj === "object" && obj !== null) {
        const isEmpty = Array.isArray(obj)
          ? obj.length === 0
          : Object.keys(obj).length === 0;

        if (isEmpty) {
          return (
            <Flex justifyContent="flex-end" mt={2}>
              <Popover placement="left">
                <PopoverTrigger>
                  <IconButton
                    aria-label="Add"
                    size={{
                      base: "xs",
                      md: "sm",
                    }}
                    icon={<FaPlus />}
                    bg="teal.400"
                    color="white"
                    _hover={{
                      bg: "teal.500",
                    }}
                  />
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverHeader>Select Action</PopoverHeader>
                  <PopoverBody>
                    <Grid gap={2}>
                      <Flex alignItems="center" justifyContent="center" gap={2}>
                        <Button
                          bg="#fd7474"
                          color="white"
                          w="10rem"
                          onClick={() =>
                            addData(parentPath, 0, "above", nested)
                          }
                        >
                          Add Field
                        </Button>
                      </Flex>
                      <Flex alignItems="center" justifyContent="center" gap={2}>
                        <Button
                          bg="#79dd79"
                          w="10rem"
                          color="white"
                          onClick={() =>
                            setOpenKeyModal({
                              open: true,
                              key: "",
                              keyPath: parentPath,
                              index: 0,
                              position: "above",
                              nested: nested,
                              type: "object",
                            })
                          }
                        >
                          Add Object
                        </Button>
                      </Flex>
                      <Flex alignItems="center" justifyContent="center" gap={2}>
                        <Button
                          bg="#7a9cff"
                          color="white"
                          w="10rem"
                          onClick={() =>
                            setOpenKeyModal({
                              open: true,
                              key: "",
                              keyPath: parentPath,
                              index: 0,
                              position: "above",
                              nested: nested,
                              type: "array",
                            })
                          }
                        >
                          Add Array
                        </Button>
                      </Flex>
                    </Grid>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Flex>
          );
        }
      }
      return Object.entries(obj).map(([key, value]: any, index) => {
        const currentPath = [...parentPath, key];
        const pathKey = currentPath.join(".");
        if (typeof value === "object" && value !== null) {
          if ("originalValues" in value || "editedValues" in value) {
            return (
              <Flex
                key={pathKey}
                alignItems="center"
                justifyContent="space-between"
                columnGap={4}
                mt={5}
              >
                <Box width="100%">
                  <CustomInput
                    label={
                      typeof key === "number"
                        ? undefined
                        : convertCamelCaseToSentence(key)
                    }
                    value={value.editedValues ?? value.originalValues ?? ""}
                    onChange={(e) => handleUpdate(currentPath, e.target.value)}
                    placeholder={`Enter ${key}`}
                    isReadOnly={
                      Array.isArray(workFlowData?.fieldsToDisable)
                        ? !workFlowData.fieldsToDisable.includes(
                            accountDetails?.level
                          )
                        : true
                    }
                    name={key}
                    style={{
                      border:
                        value.editedValues &&
                        value.originalValues !== value.editedValues
                          ? "2px solid #F56565"
                          : undefined,
                    }}
                    floating={true}
                  />

                  {value?.originalValues ? (
                    value?.editedValues ? (
                      value.originalValues !== value.editedValues ? (
                        <Text
                          mt={1}
                          fontSize="sm"
                          color="gray.600"
                          fontStyle="italic"
                        >
                          Original:{" "}
                          <Text as="span" color="red.500" fontWeight="semibold">
                            {value.originalValues || "—"}
                          </Text>
                        </Text>
                      ) : null
                    ) : null
                  ) : null}
                </Box>

                <Flex gap={2}>
                  <IconButton
                    display="none"
                    icon={<DeleteIcon />}
                    colorScheme="red"
                    size={{
                      base: "xs",
                      md: "sm",
                    }}
                    aria-label="Delete field"
                    onClick={() => deleteData(pathKey)}
                  />
                  <Popover placement="left">
                    <PopoverTrigger>
                      <IconButton
                        display="none"
                        aria-label="Add"
                        size={{
                          base: "xs",
                          md: "sm",
                        }}
                        icon={<FaPlus />}
                        bg="teal.400"
                        color="white"
                        _hover={{
                          bg: "teal.500",
                        }}
                      />
                    </PopoverTrigger>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverHeader>Select Position </PopoverHeader>
                      <PopoverBody>
                        <Grid gap={2}>
                          <Text fontWeight={700}>Fields:</Text>
                          <Flex
                            alignItems="center"
                            justifyContent="center"
                            gap={2}
                          >
                            <Button
                              bg="#fd7474"
                              color="white"
                              onClick={() =>
                                addData(
                                  parentPath.length === 0 ? key : parentPath,
                                  index,
                                  "above",
                                  nested
                                )
                              }
                            >
                              Add Above
                            </Button>
                            <Button
                              bg="#fd7474"
                              color="white"
                              onClick={() =>
                                addData(
                                  parentPath.length === 0 ? key : parentPath,
                                  index,
                                  "below",
                                  nested
                                )
                              }
                            >
                              Add Below
                            </Button>
                          </Flex>
                          <Text fontWeight={700}>Objects:</Text>
                          <Flex
                            alignItems="center"
                            justifyContent="center"
                            gap={2}
                          >
                            <Button
                              bg="#79dd79"
                              color="white"
                              onClick={() =>
                                setOpenKeyModal({
                                  open: true,
                                  key: "",
                                  keyPath:
                                    parentPath.length === 0 ? key : parentPath,
                                  index: index,
                                  position: "above",
                                  nested: nested,
                                  type: "object",
                                })
                              }
                            >
                              Add Above
                            </Button>
                            <Button
                              bg="#79dd79"
                              color="white"
                              onClick={() =>
                                setOpenKeyModal({
                                  open: true,
                                  key: "",
                                  keyPath:
                                    parentPath.length === 0 ? key : parentPath,
                                  index: index,
                                  position: "below",
                                  nested: nested,
                                  type: "object",
                                })
                              }
                            >
                              Add Below
                            </Button>
                          </Flex>

                          <Text fontWeight={700}>Array:</Text>
                          <Flex
                            alignItems="center"
                            justifyContent="center"
                            gap={2}
                          >
                            <Button
                              bg="#7a9cff"
                              color="white"
                              onClick={() =>
                                setOpenKeyModal({
                                  open: true,
                                  key: "",
                                  keyPath:
                                    parentPath.length === 0 ? key : parentPath,
                                  index: index,
                                  position: "above",
                                  nested: nested,
                                  type: "array",
                                })
                              }
                            >
                              Add Above
                            </Button>
                            <Button
                              bg="#7a9cff"
                              color="white"
                              onClick={() =>
                                setOpenKeyModal({
                                  open: true,
                                  key: "",
                                  keyPath:
                                    parentPath.length === 0 ? key : parentPath,
                                  index: index,
                                  position: "below",
                                  nested: nested,
                                  type: "array",
                                })
                              }
                            >
                              Add Below
                            </Button>
                          </Flex>
                        </Grid>
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                </Flex>
              </Flex>
            );
          }

          return (
            <Box
              key={pathKey}
              mt={4}
              borderWidth="1px"
              borderRadius="md"
              boxShadow="sm"
              overflow="hidden"
            >
              <Heading
                size="sm"
                px={4}
                py={2}
                bg="gray.100"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                cursor="pointer"
                onClick={() => toggleCollapse(pathKey)}
                _hover={{ bg: "gray.200", color: "blue.600" }}
              >
                <Text textTransform="capitalize" flex="1">
                  {convertCamelCaseToSentence(key)}
                </Text>
                {collapsed[pathKey] ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronDownIcon />
                )}
              </Heading>
              <Collapse in={!collapsed[pathKey]} animateOpacity>
                <Box
                  bg="white"
                  p={4}
                  pt={0}
                  pb={0}
                  borderTopWidth="1px"
                  borderTopColor="gray.200"
                >
                  {renderFields(value, currentPath, true)}
                </Box>
              </Collapse>
              <Flex justifyContent="flex-end">
                <Popover placement="left">
                  <PopoverTrigger>
                    <Button
                      mt={4}
                      mb={2}
                      mr={4}
                      size="sm"
                      leftIcon={<AddIcon />}
                      colorScheme="green"
                      variant="outline"
                      _hover={{ bg: "green.50" }}
                    >
                      Action
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverHeader>Select Position </PopoverHeader>
                    <PopoverBody>
                      <Grid gap={2}>
                        <Text fontWeight={700}>Fields:</Text>
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          gap={2}
                        >
                          <Button
                            bg="#fd7474"
                            color="white"
                            onClick={() =>
                              addData(
                                parentPath.length === 0 ? key : parentPath,
                                index,
                                "above",
                                nested
                              )
                            }
                          >
                            Add Above
                          </Button>
                          <Button
                            bg="#fd7474"
                            color="white"
                            onClick={() =>
                              addData(
                                parentPath.length === 0 ? key : parentPath,
                                index,
                                "below",
                                nested
                              )
                            }
                          >
                            Add Below
                          </Button>
                        </Flex>
                        <Text fontWeight={700}>Objects:</Text>
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          gap={2}
                        >
                          <Button
                            bg="#79dd79"
                            color="white"
                            onClick={() =>
                              setOpenKeyModal({
                                open: true,
                                key: "",
                                keyPath:
                                  parentPath.length === 0 ? key : parentPath,
                                index: index,
                                position: "above",
                                nested: nested,
                                type: "object",
                              })
                            }
                          >
                            Add Above
                          </Button>
                          <Button
                            bg="#79dd79"
                            color="white"
                            onClick={() =>
                              setOpenKeyModal({
                                open: true,
                                key: "",
                                keyPath:
                                  parentPath.length === 0 ? key : parentPath,
                                index: index,
                                position: "below",
                                nested: nested,
                                type: "object",
                              })
                            }
                          >
                            Add Below
                          </Button>
                        </Flex>
                        <Text fontWeight={700}>Array:</Text>
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          gap={2}
                        >
                          <Button
                            bg="#7a9cff"
                            color="white"
                            onClick={() =>
                              setOpenKeyModal({
                                open: true,
                                key: "",
                                keyPath:
                                  parentPath.length === 0 ? key : parentPath,
                                index: index,
                                position: "above",
                                nested: nested,
                                type: "array",
                              })
                            }
                          >
                            Add Above
                          </Button>
                          <Button
                            bg="#7a9cff"
                            color="white"
                            onClick={() =>
                              setOpenKeyModal({
                                open: true,
                                key: "",
                                keyPath:
                                  parentPath.length === 0 ? key : parentPath,
                                index: index,
                                position: "below",
                                nested: nested,
                                type: "array",
                              })
                            }
                          >
                            Add Below
                          </Button>
                        </Flex>
                      </Grid>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </Flex>
            </Box>
          );
        }
        return null;
      });
    };

    return (
      <Box
        p={6}
        borderWidth="1px"
        borderRadius="md"
        maxW="800px"
        mx="auto"
        bg="white"
        boxShadow="lg"
      >
        <VStack align="stretch" spacing={0}>
          {renderFields(payload)}
        </VStack>

        <Modal
          isOpen={openAddModal.open}
          onClose={() =>
            setOpenAddModal((prev: any) => ({ ...prev, open: false }))
          }
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader
              color="teal.300"
              fontSize={{ base: "lg", md: "2xl" }}
              fontWeight="700"
            >
              Add New Field
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Key</FormLabel>
                <Input
                  placeholder="Enter key"
                  value={openAddModal.key}
                  onChange={(e) =>
                    setOpenAddModal((prev: any) => ({
                      ...prev,
                      key: e.target.value,
                    }))
                  }
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Value</FormLabel>
                <Input
                  placeholder="Enter value"
                  value={openAddModal.data.editedValues}
                  onChange={(e) =>
                    setOpenAddModal((prev: any) => ({
                      ...prev,
                      data: { ...prev.data, editedValues: e.target.value },
                    }))
                  }
                />
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Flex gap={3} justifyContent="flex-end">
                <Button colorScheme="green" w="5rem" onClick={addModalData}>
                  Add
                </Button>
                <Button
                  colorScheme="red"
                  w="5rem"
                  onClick={() =>
                    setOpenAddModal((prev: any) => ({ ...prev, open: false }))
                  }
                >
                  Cancel
                </Button>
              </Flex>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal
          isOpen={openKeyModal.open}
          onClose={() =>
            setOpenKeyModal((prev: any) => ({ ...prev, open: false }))
          }
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add Key</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Input
                placeholder="Enter key name"
                value={openKeyModal.key}
                onChange={(e) =>
                  setOpenKeyModal((prev: any) => ({
                    ...prev,
                    key: e.target.value,
                  }))
                }
                mb={4}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="blue"
                onClick={() =>
                  addEmptyObject(
                    openKeyModal.keyPath,
                    openKeyModal.key,
                    openKeyModal.index,
                    openKeyModal.position as "above" | "below",
                    openKeyModal.nested,
                    openKeyModal.type
                  )
                }
                isDisabled={!openKeyModal.key}
              >
                Add
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    );
  }
);

export default DynamicForm;
